import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_BLACK_HISTORY_LOGO = createFcmConfig('enable_black_history_logo', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
